
 

 

 

 
class ActivateTokenRequest 
{
    
        IsChangePassword: boolean;
    
        TokenKey: string;
    
        ResourceUID: string;
    
}
 
export default ActivateTokenRequest;
 




